import {
  StressReduce,
  MovingMore,
  HealthyEat,
  GreenMoon,
  BludDrop,
  Thunder,
  Notes,
  YelloPerson,
  TargetGreen,
  OrangeApple,
} from "@utils/defaultImages";

export const quizTypesData = [
  {
    label: "Reduce Stress",
    key: "stress",
    icon: StressReduce,
    tabColor: "#FFF6F0",
    value: "Learn quick techniques to calm your mind.",
    border: "#FF8B38",
  },
  {
    label: "Eat Healthier",
    key: "eatHealthy",
    icon: HealthyEat,
    tabColor: "#F0FEFF",
    value: "Fuel your body with balanced, tasty meals.",
    border: "#64DDFF",
  },
  {
    label: "Moving More",
    key: "moving",
    icon: MovingMore,
    tabColor: "#FFF0FB",
    value: "Stay active with workouts that fit your routine.",
    border: "#FF56DA",
  },
  {
    label: "Improve Sleep",
    key: "sleep",
    icon: GreenMoon,
    tabColor: "#F0FFF4",
    value: "Build knowledge and habits for better rest.",
    border: "#64FFC1",
  },
  {
    label: "Stay Hydrated",
    key: "hydration",
    icon: BludDrop,
    tabColor: "#F0F5FF",
    value: "Learn about hydration benefits and reminders.",
    border: "#647EFF",
  },
  {
    label: "Boost Energy",
    key: "energy",
    icon: Thunder,
    tabColor: "#FFF0F0",
    value: "Focus on foods, workouts, and habits that increase daily energy.",
    border: "#FF5659",
  },
  {
    label: "Build Consistency",
    key: "consistency",
    icon: Notes,
    tabColor: "#FEF0FF",
    value: "Motivate sticking to daily routines and streaks.",
    border: "#B638FF",
  },
  {
    label: "Build Confidence",
    key: "confidence",
    icon: YelloPerson,
    tabColor: "#FDFFF0",
    value: "Quizzes reinforce positive habits and self-belief.",
    border: "#FFD738",
  },
  {
    label: "Sharpen Focus",
    key: "focus",
    icon: TargetGreen,
    tabColor: "#F0FFF1",
    value: "Improve concentration, productivity, and mental clarity.",
    border: "#ADFF56",
  },
  {
    label: "Weight Loss Wisdom",
    key: "focus",
    icon: OrangeApple,
    tabColor: "#FFF7F0",
    value: "Improve concentration, productivity, and mental clarity.",
    border: "#FF8B38",
  },
];
